exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.linked-task-files[data-v-364989a2] {\n    display: flex;\n    flex-wrap: wrap;\n    gap: 6px;\n    margin-top: 8px;\n}\n.linked-task-file[data-v-364989a2] {\n    display: inline-flex;\n    align-items: center;\n    gap: 4px;\n    padding: 4px 8px;\n    border-radius: 6px;\n    background: #f3f4f6;\n    color: var(--primary);\n    font-size: 12px;\n    cursor: pointer;\n}\n", ""]);

// exports
